import React from "react"

export default function MagnifyIcon() {
  return (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M60 39.8889H50.599L54.3982 35.9722C50.6128 32.2222 44.4841 32.0833 40.6987 35.8333C36.9134 39.5972 36.9134 45.6667 40.6987 49.4306C44.4841 53.1944 50.6128 53.1944 54.3982 49.4306C56.284 47.5694 57.2269 45.3889 57.2269 42.6389H60C60 45.3889 58.7798 48.9583 56.3394 51.375C51.4725 56.2083 43.569 56.2083 38.7021 51.375C33.849 46.5556 33.8074 38.7222 38.6743 33.9028C43.5412 29.0833 51.3477 29.0833 56.2146 33.9028L60 30V39.8889Z"
        fill="#B9D7FF"
      />
      <path
        className="white-fill"
        d="M30.1885 3C17.0891 3 6.43255 13.6683 6.43255 26.7805C6.43255 32.5484 8.49431 37.8431 11.9188 41.9649L0.642514 53.2529C-0.214171 54.1097 -0.214171 55.5 0.642514 56.3568C1.07091 56.7856 1.63227 57 2.19289 57C2.75426 57 3.31498 56.7856 3.74328 56.3568L15.0196 45.0689C19.033 48.4103 24.1595 50.4557 29.7519 50.5571C32 50.5571 32 46.1661 29.7519 46.1661C19.272 45.9329 10.8183 37.3262 10.8183 26.7805C10.8183 16.0888 19.5079 7.39026 30.1885 7.39026C40.4394 7.39026 48.8562 15.4029 49.517 25.5C49.517 27.5 53.9105 27.5 53.9105 25.5C53.2436 12.9808 42.8581 3 30.1885 3Z"
        fill="#4996FF"
      />
    </svg>
  )
}
